import * as React from 'react';
import { localizations } from '../localization/localization';
import { ApplicationState } from '../store';

interface ZeckitWidgetProps {
    businessId: string;
}

class ZeckitLargeWidget extends React.Component<ZeckitWidgetProps, {}>{
    constructor(props: ZeckitWidgetProps) {
        super(props);
    }

    public componentDidMount() {
        const zeckitScript = document.createElement("script");

        zeckitScript.src = "https://zeckit.com/wordpress/wp-content/themes/hyva_yritys/library/js/zeckit-widget.js";
        zeckitScript.async = true;

        document.body.appendChild(zeckitScript);
    }

    public render() {
        const { businessId } = this.props;
        return (
            <div style={{height: "200px"}}>
                <div className="zeckit-widget"  data-locale="fi" style={{display:"flex", alignItems: "center"}}>
                    <a href="https://zeckit.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none", paddingRight: "15px"}}>
                        <img src="https://zeckit.com/selvitys/images/z_musta.png" height="40" />   
                    </a>
                <a className="zeckit-statement-link" href={"https://zeckit.com/selvitys/FI/" + businessId + "?lang=fi"} target="_blank" rel="noopener noreferrer" style={{paddingLeft:"15px" , color:"#3d3d3d", borderLeft:"1px solid #000"}}>
                    {localizations.zeckit.viewCompanyStatement}
                </a>
                </div>
            </div>
        );
    }
}

export default ZeckitLargeWidget;


// WEBPACK FOOTER //
// ./src/common/ZeckitLargeWidget.tsx